var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownWhiteArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.001,
    height: 85.563,
    viewBox: "0 0 150.001 85.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19272",
    "data-name": "Path 19272",
    d: "M130.727,202.3c1.224,1.167,2,1.879,2.749,2.624Q160.2,231.639,186.9,258.369c3.158,3.166,6.658,5.084,11.271,3.828a10.369,10.369,0,0,0,5.571-16.561,27.421,27.421,0,0,0-2.382-2.577q-30.646-30.661-61.3-61.309c-6.3-6.3-11.784-6.277-18.131.069Q91.066,212.676,60.2,243.527c-3.266,3.258-5.1,6.877-3.68,11.569a10.366,10.366,0,0,0,16.058,5.527,24.853,24.853,0,0,0,3.04-2.739q26.418-26.4,52.808-52.819C129.18,204.307,129.8,203.418,130.727,202.3Z",
    transform: "translate(206.031 262.606) rotate(180)",
    fill: "#fffbf5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownWhiteArrow);
export default __webpack_public_path__ + "static/media/Down_White_Arrow.6f925490fa48f7488a16e773fe7c0fcd.svg";
export { ForwardRef as ReactComponent };